import React from "react";
import { NotFoundHeader, NotFoundContent } from "./css";
import Footer from "../Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Nav, NavNotLoggedIn } from "../Nav";

const NotFound = (props) => {
    
    return (
        <div>
          {
            props.isSignedIn ? 
              <Nav activePage="" /> : 
              <NavNotLoggedIn />
          }
            <NotFoundHeader>Page Not Found</NotFoundHeader>
            <NotFoundContent>Sorry the page you are looking for cannot be found, try using the menu above</NotFoundContent>
            <Footer></Footer>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn
    };
};

export default withRouter(
  connect(mapStateToProps, null)(NotFound)
);

